import { render, staticRenderFns } from "./FederalHolidays.vue?vue&type=template&id=5c2310a8&scoped=true&"
import script from "./FederalHolidays.vue?vue&type=script&lang=js&"
export * from "./FederalHolidays.vue?vue&type=script&lang=js&"
import style0 from "./FederalHolidays.vue?vue&type=style&index=0&id=5c2310a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2310a8",
  null
  
)

export default component.exports